import { PRODUCTS } from '../../constants';
import config from '../../../../../config';
import constants from '../../../../../ahm-constants';

const REDIRECTS = {
  [PRODUCTS.CAR]: constants.URLS.SALES.CAR_INSURANCE_SUCCESS,
  [PRODUCTS.HOME]: constants.URLS.SALES.HOME_INSURANCE_SUCCESS,
};

const REDIRECT_BACKS = {
  [PRODUCTS.CAR]: constants.URLS.SALES.CAR_INSURANCE,
  [PRODUCTS.HOME]: constants.URLS.SALES.HOME_INSURANCE,
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getAbsoluteUrl = (path) => `${config.get('sales:url')}${path}`;

// @ts-expect-error - Automatic, Please fix when editing this file
export const getRedirect = (productSlug) => getAbsoluteUrl(REDIRECTS[productSlug] || constants.URLS.SALES.HOME);
// @ts-expect-error - Automatic, Please fix when editing this file
export const getRedirectBack = (productSlug) =>
  getAbsoluteUrl(REDIRECT_BACKS[productSlug] || constants.URLS.SALES.HOME);
